import { useEffect, useState } from 'react';
import { answerShown, WRONG_ANSWER_REVEAL_MS } from '../domain/answer-feedback';

/**
 * The feedback state for the sum on screen (`answerLook`, `answerShown`): a wrong pick waits
 * `WRONG_ANSWER_REVEAL_MS` before the right answer lights up; the next sum (no pick) starts
 * over.
 */
export function useAnswerReveal(picked: number | string | null, correct: number | string) {
  const [revealed, setRevealed] = useState(false);
  const wrong = picked !== null && picked !== correct;
  useEffect(() => {
    setRevealed(false);
    if (!wrong) return;
    const timer = setTimeout(() => setRevealed(true), WRONG_ANSWER_REVEAL_MS);
    return () => clearTimeout(timer);
  }, [wrong]);
  const state = { picked, correct, revealed };
  return { state, shown: answerShown(state) };
}
